<app-synchronization-form
  data-testid="synchronization-add-form-wrapper"
  #formWrapper
  [config]="config"
  [editMode]="false"
  [viewMode]="false"
></app-synchronization-form>
